import { RouteName } from './route-names';
export const routePaths = {
    [RouteName.Main]: {
        en: '/where-to-find',
        et: '/kust-leida',
        ru: '/gde-naiti',
    },
    [RouteName.AllStoresWithParameter]: {
        en: '/where-to-find/all-stores/:id',
        et: '/kust-leida/koik-poed/:id',
        ru: '/gde-naiti/vse-mesta/:id',
    },
    [RouteName.AllStores]: {
        en: '/where-to-find/all-stores',
        et: '/kust-leida/koik-poed',
        ru: '/gde-naiti/vse-mesta',
    },
    [RouteName.IqosStores]: {
        en: '/where-to-find/iqos-stores',
        et: '/kust-leida/Q-store-poed',
        ru: '/gde-naiti/Q-store-magazinq',
    },
    [RouteName.PartnerStores]: {
        en: '/where-to-find/partner-stores',
        et: '/kust-leida/Q-partner-poed',
        ru: '/gde-naiti/Q-partner-magazinq',
    },
    [RouteName.ResellerStores]: {
        en: '/where-to-find/:reseller-stores',
        et: '/kust-leida/:edasimuujad',
        ru: '/gde-naiti/:reseller-mesta',
    },
    [RouteName.User]: {
        en: '/where-to-find/user',
        et: '/kust-leida/kasutaja',
        ru: '/gde-naiti/polzovatel',
    },
    [RouteName.Recharge]: {
        en: '/where-to-find/user/recharge',
        et: '/kust-leida/kasutaja/taaslaadimine',
        ru: '/gde-naiti/polzovatel/podzaryadka',
    },
    [RouteName.Maintenance]: {
        en: '/where-to-find/user/maintenance',
        et: '/kust-leida/kasutaja/hooldus',
        ru: '/gde-naiti/polzovatel/obsluzhivanie',
    },
    [RouteName.Clean]: {
        en: '/where-to-find/user/clean',
        et: '/kust-leida/kasutaja/puhastamine',
        ru: '/gde-naiti/polzovatel/chistka',
    },
    [RouteName.Customize]: {
        en: '/where-to-find/user/customize',
        et: '/kust-leida/kasutaja/kohanda',
        ru: '/gde-naiti/polzovatel/personalizirovat',
    },
    [RouteName.Accessories]: {
        en: '/where-to-find/user/customize/accessories',
        et: '/kust-leida/kasutaja/kohanda/aksessuaarid',
        ru: '/gde-naiti/polzovatel/personalizirovat/aksessuary',
    },
    [RouteName.Engraving]: {
        en: '/where-to-find/user/customize/engraving',
        et: '/kust-leida/kasutaja/kohanda/graveerimine',
        ru: '/gde-naiti/polzovatel/personalizirovat/gravirovka',
    },
    [RouteName.BuyHeets]: {
        en: '/where-to-find/user/buy-heets',
        et: '/kust-leida/kasutaja/kust-osta-kuumutatavaid-tubakapulki-heets',
        ru: '/gde-naiti/polzovatel/kupit-izdeliia-iz-nagrevaemogo-tabaka-heets',
    },
    [RouteName.BuyTerea]: {
        en: '/where-to-find/user/buy-terea',
        et: '/kust-leida/kasutaja/kust-osta-kuumutatavaid-tubakapulki-terea',
        ru: '/gde-naiti/polzovatel/kupit-izdeliia-iz-nagrevaemogo-tabaka-terea',
    },
    [RouteName.BuyFiit]: {
        en: '/where-to-find/user/buy-fiit',
        et: '/kust-leida/kasutaja/kust-osta-kuumutatavaid-tubakapulki-fiit',
        ru: '/gde-naiti/polzovatel/kupit-izdeliia-iz-nagrevaemogo-tabaka-fiit',
    },
    [RouteName.BuyVeev]: {
        en: '/where-to-find/buy-veev',
        et: '/kust-leida/kust-osta-veev',
        ru: '/gde-naiti/kupit-veev',
    },
    [RouteName.BuyZyn]: {
        en: '/where-to-find/buy-zyn',
        et: '/kust-leida/kust-osta-zyn',
        ru: '/gde-naiti/kupit-zyn',
    },
    [RouteName.BuyIqos]: {
        en: '/where-to-find/buy-iqos',
        et: '/kust-leida/kust-osta-iqos',
        ru: '/gde-naiti/kupit-iqos',
    },
    [RouteName.BuyLilSolidEz]: {
        en: '/buy-lil-solid-ez',
        et: '/kust-leida/kust-osta-lil-solid-ez',
        ru: '/gde-naiti/kupit-lil-solid-ez',
    },
    [RouteName.New]: {
        en: '/where-to-find/new',
        et: '/kust-leida/uus',
        ru: '/gde-naiti/novyi',
    },
    [RouteName.LendIqos]: {
        en: '/where-to-find/new/lend-iqos',
        et: '/kust-leida/uus/iqos-laenutamine',
        ru: '/gde-naiti/novyi/testirovat-iqos',
    },
    [RouteName.Contact]: {
        en: '/contact',
        et: '/vota-meiega-uhendust',
        ru: '/kontaktnaja-informacija',
    },
    [RouteName.SubmitQuestion]: {
        en: '/where-to-find/contact/question',
        et: '/vota-meiega-uhendust/kusimused',
        ru: '/kontaktnaja-informacija/voprosy',
    },
};
